const access = {
  ADMIN: "Admin",
  MARKET_EXPERT: "Market Expert",
  STOCKANTS_ADMIN: "StockAnts Admin",
  BROKER_ADMIN: "Broker Admin",
  BROKER_ASSOCIATE: 'Broker Associate'
};

exports.access = access;
